module.exports = __webpack_public_path__ + "images/graphic-about_4e13daae5996e81919f7d5c641f4a9b8.png";